module.exports = __webpack_public_path__ + "img/FullCover_Chi4.d51911f8.jpg";